import { call, put, takeEvery, takeLatest } from "redux-saga/effects"

import {
  GET_ADMIN_INTERNAL_USERS,
  GET_ALL_ADMIN_EMPLOYEES,
  CREATE_ADMIN_INTERNAL_USER,
  MODIFY_ADMIN_INTERNAL_USER,
  DELETE_ADMIN_INTERNAL_USER,
  CREATE_BULK_ADMIN_INTERNAL_USER,
  RESEND_ADMIN_INTERNAL_USER_INVITE,
  MODIFY_BULK_ADMIN_INTERNAL_USER,
  DELETE_BULK_ADMIN_INTERNAL_USER
} from "./actionTypes"

import {
  getAdminInternalUsersSuccess,
  getAdminInternalUsersError,
  getAllAdminEmployeesSuccess,
  getAllAdminEmployeesError,
  createAdminInternalUserSuccess,
  createAdminInternalUserError,
  updateAdminInternalUserSuccess,
  updateAdminInternalUserError,
  deleteAdminInternalUserSuccess,
  deleteAdminInternalUserError,
  createBulkAdminInternalUserSuccess,
  createBulkAdminInternalUserError,
  resendAdminInternalUserInviteError,
  resendAdminInternalUserInviteSuccess,
  updateBulkAdminInternalUserSuccess,
  deleteBulkAdminInternalUserSuccess
} from "./actions"

import { genericDeleteRequest, genericGetRequest, genericGetRequest_2, genericPostRequest, genericPutRequest } from "helpers/sf_backend_helper.js"

import { AppConfiguration } from "config"
import { bsh_getAdminUserDetails } from "helpers/sf_browser_storage_helper"
import { USER_INVITE_STR } from "common/sf_strings"

function* onGetAdminInternalUsers(action) {
  try {
    let user = bsh_getAdminUserDetails();
    const response = yield call(
      genericGetRequest_2,
      `${AppConfiguration.BACKEND_URL}/api/v1/admin_manage_employees`,
      {...action.payload?.queryParams},
      {
        Authorization: user.token,
      }
    )
    yield put(getAdminInternalUsersSuccess(response, action.paginated))
  } catch (error) {
    yield put(getAdminInternalUsersError(error))
  }
}

function* onGetAllAdminEmployees(action) {
  try {
    let user = bsh_getAdminUserDetails();
    const response = yield call(
      genericGetRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/get_all_admin_employees`,
      {}, // no query parameters
      {
        Authorization: user.token,
      }
    )
    yield put(getAllAdminEmployeesSuccess(response))
  } catch (error) {
    yield put(getAllAdminEmployeesError(error))
  }
}

function* onCreateAdminInternalUser(action) {
  try {
    let user = bsh_getAdminUserDetails();
    const response = yield call(
      genericPostRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/admin_manage_employees`,
      {
        body: JSON.stringify({
          ...action.payload
        }),
        headers: {
          Authorization: user.token,
          'Content-Type': 'application/json',
        }
      }
    )
    yield put(createAdminInternalUserSuccess(response))
  } catch (error) {
    yield put(createAdminInternalUserError(error))
  }
}

function* onCreateBulkAdminInternalUser(action) {
  try {
    let user = bsh_getAdminUserDetails();
    const response = yield call(
      genericPostRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/admin_manage_employees`,
      {
        body: JSON.stringify({
          ...action.payload
        }),
        headers: {
          Authorization: user.token,
          'Content-Type': 'application/json',
        }
      }
    )
    yield put(createBulkAdminInternalUserSuccess(response))
  } catch (error) {
    yield put(createBulkAdminInternalUserError(error))
  }
}

function* onUpdateAdminInternalUser(action) {
  try {
    let user = bsh_getAdminUserDetails();
    const response = yield call(
      genericPutRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/admin_manage_employees/${action.payload.admin_user.id}`,
      {
        body: JSON.stringify({
          ...action.payload
        }),
        headers: {
          Authorization: user.token,
          'Content-Type': 'application/json',
        }
      }
    )
    yield put(updateAdminInternalUserSuccess(response))
  } catch (error) {
    yield put(updateAdminInternalUserError(error))
  }
}

function* onUpdateBulkAdminInternalUser(action) {
  try {
    let user = bsh_getAdminUserDetails();
    const response = yield call(
      genericPutRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/admin_manage_employees/${action.payload.admin_users.map(admin_user => admin_user.id).join(',')}?bulk=1`,
      {
        body: JSON.stringify({
          ...action.payload
        }),
        headers: {
          Authorization: user.token,
          'Content-Type': 'application/json',
        }
      }
    )
    yield put(updateBulkAdminInternalUserSuccess(response))
  } catch (error) {
    yield put(updateAdminInternalUserError(error))
  }
}

function* onDeleteBulkAdminInternalUser(action) {
  try {
    let user = bsh_getAdminUserDetails();
    const response = yield call(
      genericDeleteRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/admin_manage_employees/${action.payload.admin_users.map(admin_user => admin_user.id).join(',')}?bulk=1`,
      {
        headers: {
          Authorization: user.token,
        }
      }
    )
    yield put(deleteBulkAdminInternalUserSuccess(response))
  } catch (error) {
    yield put(deleteAdminInternalUserError(error))
  }
}

function* onDeleteteAdminInternalUser(action) {
  try {
    let user = bsh_getAdminUserDetails();
    const response = yield call(
      genericDeleteRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/admin_manage_employees/${action.payload.id}`,
      {
        headers: {
          Authorization: user.token,
          'Content-Type': 'application/json'
        }
      }
    )
    yield put(deleteAdminInternalUserSuccess(response))
  } catch (error) {
    yield put(deleteAdminInternalUserError(error))
  }
}

function* onResendAdminInternalUserInvite(action) {
  try {
    let user = bsh_getAdminUserDetails();
    const response = yield call(
      genericPostRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/admin_manage_employees/resend_invite/${action.payload.id}`,
      {
        headers: {
          Authorization: user.token,
          'Content-Type': 'application/json'
        }
      }
    )
    yield put(resendAdminInternalUserInviteSuccess(response))
  } catch (error) {
    yield put(resendAdminInternalUserInviteError({type: USER_INVITE_STR.RESEND_ERROR_TYPE, message: `Failed to resend invitation to ${action.payload.email}`}))
  }
}

function* AdminManageInternalUsersSaga() {
  yield takeLatest(GET_ADMIN_INTERNAL_USERS, onGetAdminInternalUsers)
  yield takeEvery(GET_ALL_ADMIN_EMPLOYEES, onGetAllAdminEmployees)
  yield takeEvery(CREATE_ADMIN_INTERNAL_USER, onCreateAdminInternalUser)
  yield takeEvery(CREATE_BULK_ADMIN_INTERNAL_USER, onCreateBulkAdminInternalUser)
  yield takeEvery(MODIFY_ADMIN_INTERNAL_USER, onUpdateAdminInternalUser)
  yield takeEvery(MODIFY_BULK_ADMIN_INTERNAL_USER, onUpdateBulkAdminInternalUser)
  yield takeEvery(DELETE_BULK_ADMIN_INTERNAL_USER, onDeleteBulkAdminInternalUser)
  yield takeEvery(DELETE_ADMIN_INTERNAL_USER, onDeleteteAdminInternalUser)
  yield takeEvery(RESEND_ADMIN_INTERNAL_USER_INVITE, onResendAdminInternalUserInvite)
}

export default AdminManageInternalUsersSaga;
